import * as React from "react";

export type ButtonAdapter = (props: {
  children: React.ReactNode;
  onPress?: () => void;
  disabled?: boolean;
  variant?: "primary" | "ghost" | "compact" | "ghost-sm" | "overlay" | "outline";
  className?: string;
  type?: "button" | "submit" | "reset";
}) => React.ReactElement;

let impl: ButtonAdapter | null = null;
export const registerButton = (adapter: ButtonAdapter) => {
  impl = adapter;
};

export const Button: React.FC<{
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  variant?: "primary" | "ghost" | "compact" | "ghost-sm" | "overlay" | "outline";
  className?: string;
  type?: "button" | "submit" | "reset";
}> = ({ children, onClick, disabled, variant, className, type }) => {
  if (!impl) return <span style={{ display: "none" }} />;
  return impl({ children, onPress: onClick, disabled, variant, className, type });
};
